module.exports = __webpack_public_path__ + "static/media/ucon9.31611cd2.JPG";